import createClient, { Client } from "openapi-fetch";
import type { paths } from "./api.gen.d";
import { ReadonlyRequestCookies } from "next/dist/server/web/spec-extension/adapters/request-cookies";
import { getSessionId } from "./session-id";

export default function getApiClient(cookies?: ReadonlyRequestCookies): Client<paths> {
  const id_cookie = cookies?.get("id");
  const baseUrl =
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.HA_BACKEND_URL;
  if (!baseUrl) {
    throw new Error("Base URL is not defined");
  }
  const client = createClient<paths>({
    baseUrl,
    headers:
      id_cookie ? { "Cookie": `id=${id_cookie.value}` } : {},
  });

  // Tag every browser request with the session id so backend traces/logs can be
  // correlated to the user's session. (`traceparent` is injected separately by
  // the OTel fetch instrumentation when telemetry is enabled.) No-op during SSR.
  client.use({
    onRequest({ request }) {
      const sessionId = getSessionId();
      if (sessionId) {
        request.headers.set("x-session-id", sessionId);
      }
      return request;
    },
  });

  return client;
}